import React from 'react';
import { Fade } from 'react-slideshow-image';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import styles from './slideshow.module.css';


const fadeProperties = {
  duration: 5000,
  transitionDuration: 1000,
  infinite: true,
  arrows: false,
};
const Slideshow = ({ children }) => {
  const data = useStaticQuery(graphql`
  query {
    one: file(relativePath: { eq: "brownie.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    two: file(relativePath: { eq: "bread.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    three: file(relativePath: { eq: "bullar_bread.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    four: file(relativePath: { eq: "working.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    five: file(relativePath: { eq: "entre.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    six: file(relativePath: { eq: "smoothies.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`);
  return (
    <div className={styles.slideContainer}>
      <Fade {...fadeProperties}>
        <Img className={styles.imgSlide} fluid={data.one.childImageSharp.fluid} />
        <Img className={styles.imgSlide} fluid={data.two.childImageSharp.fluid} />
        <Img
          className={styles.imgSlide}
          fluid={data.three.childImageSharp.fluid}
        />
        <Img
          className={styles.imgSlide}
          fluid={data.four.childImageSharp.fluid}
        />
        <Img
          className={styles.imgSlide}
          fluid={data.five.childImageSharp.fluid}
        />
        <Img
          className={styles.imgSlide}
          fluid={data.six.childImageSharp.fluid}
        />
      </Fade>
      <div className={styles.wrapper}>
        {children}
      </div>
    </div>
  );
};


export default Slideshow;
